import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import * as firebase from 'firebase';
import { AlertService } from '../../../_services/alert.service';
import { v4 as uuidv4 } from 'uuid';
import * as _ from 'underscore';
import Swal from 'sweetalert2/dist/sweetalert2.js';
@Component({
  selector: 'app-cab-activity',
  templateUrl: './cab-activity.component.html',
  styleUrls: ['./cab-activity.component.css']
})
export class CabActivityComponent implements OnInit {

  modalRef: any;
  d10: any;
  d11: any;
  iconTab: FormGroup;
  meals = ['Yes', 'No'];
  members = ['Walter White', 'Jessy Pinkman', 'Heisenberg', 'Skylar White', 'Saul Goodman']
  modes = ['Bus', 'Train']
  mealTypes = ['Personal', 'Client', 'Team']
  mealSession = ['Breakfast', 'Lunch', 'Dinner', 'Others']

  private activityList: Array<any> = [];
  tagList = [];
  isLoading: any = false;
  isUploading: any = false;
  selectedItems = [];
  snapList: any = [];
  diffList = [];
  dropdownSettings = {};
  keyIndex: any = -1;
  minDate: any;
  maxDate: any;
  startDate: any;
  currMinDate: any;
  currMaxDate: any;
  addedBy: any;
  verifyFields = [
    {
      "key": "pickPoint",
      "value": "PickupPoint"
    },
    {
      "key": "meetingStartDate",
      "value": "CabStartDate",
      "isDate": true
    },
    {
      "key": "meetingEndDate",
      "value": "CabEndDate",
      "isDate": true
    },
    {
      "key": "pickTime",
      "value": "PickTime"
    },
    {
      "key": "estDropTime",
      "value": "EstDropTime"
    },
    {
      "key": "dropPoint",
      "value": "DropOffPoint"
    },
    {
      "key": "tagMembersMeet",
      "value": "TagMembersCab"
    },
    {
      "key": "otherInfoCab",
      "value": "OtherInfoCab"
    },
    {
      "key": "transNumberCab",
      "value": "TransNumberCab"
    },
    {
      "key": "merchNameCab",
      "value": "MerchNameCab"
    },
    {
      "key": "totalCabKms",
      "value": "TotalCabKms"
    },
    {
      "key": "cabCategory",
      "value": "CabCategory"
    }
  ]

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private alertService: AlertService
  ) {
    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
    this.maxDate = {
      year: current.getFullYear(),
      month: current.getMonth(),
      day: current.getDate(),
    };
  }

  @Input() data: any;
  @Input() travellers: any;
  @Input() createdBy: any;
  @Input() code: any;
  @Input() isReadOnly: any;
  @Input() isDisabled: any;
  @Input() isActivityEdit: any;
  @Output() flightData: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {
    this.iconTab = this.formBuilder.group({
      activityDetails: [[]],

      // Cab/Rentals Activity
      pickPoint: ['', Validators.required],
      dropPoint: ['', Validators.required],
      meetingStartDate: ['', Validators.required],
      // cabStartDate: ['', Validators.required],
      meetingEndDate: ['', Validators.required],
      // cabEndDate: ['', Validators.required],
      meetingStart: ['', Validators.required],
      meetingEnd: ['', Validators.required],
      // cabStart: ['', Validators.required],
      // cabEnd: ['', Validators.required],
      pickTime: ['', Validators.required],
      estDropTime: ['', Validators.required],
      tagMembersMeet: ['', Validators.required],
      // tagMembersCab: ['', Validators.required],
      otherInfoCab: ['', Validators.required],
      transNumberCab: ['', Validators.required],
      merchNameCab: ['', Validators.required],
      totalCabKms: ['', Validators.required],
      cabCategory: ['', Validators.required],
      createdBy: ['', Validators.required],

    });

    this.tagList = this.travellers;
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.iconTab.patchValue(this.data);
    this.addedBy = this.data ? this.data.createdBy : this.createdBy;
    this.createdBy = this.data ? this.data.createdBy : this.createdBy + " - " + this.code;
    this.snapList = this.data ? this.data.snapList : '' || [];
    this.selectedItems = this.data ? this.data.tagMembersMeet : [];
    this.diffList = this.data && this.data.activityDiffList || [];
    console.log('data@@', this.data)
  }

  displayMembers(allMembers: any) {
    // console.log(allMembers);
    allMembers = allMembers.toString().replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ',  ');
    return allMembers;
  }



  cabRentalActivity() {
    // this.isLoading = true
    this.activityList.push({
      category: "Cab",
      pickPoint: this.iconTab.value.pickPoint,
      dropPoint: this.iconTab.value.dropPoint,
      meetingStartDate: this.iconTab.value.meetingStartDate,
      meetingEndDate: this.iconTab.value.meetingEndDate,
      meetingStart: this.iconTab.value.meetingStart,
      meetingEnd: this.iconTab.value.meetingEnd,
      pickTime: this.iconTab.value.pickTime,
      estDropTime: this.iconTab.value.estDropTime,
      tagMembersMeet: this.iconTab.value.tagMembersMeet,
      otherInfoCab: this.iconTab.value.otherInfoCab,
      transNumberCab: this.iconTab.value.transNumberCab,
      merchNameCab: this.iconTab.value.merchNameCab,
      totalCabKms: this.iconTab.value.totalCabKms,
      cabCategory: this.iconTab.value.cabCategory,
    })
    this.iconTab.patchValue({
      activityDetails: this.activityList,
      category: "Cab",
      pickPoint: '',
      dropPoint: '',
      meetingStartDate: '',
      meetingEndDate: '',
      meetingStart: '',
      meetingEnd: '',
      pickTime: '',
      estDropTime: '',
      tagMembersMeet: '',
      otherInfoCab: '',
      transNumberCab: '',
      merchNameCab: '',
      totalCabKms: '',
      cabCategory: '',
    })
  }

  get f() {
    return this.iconTab.controls;
  }

  editCabActivity(index, content) {
    this.modalRef = this.modalService.open(content, { windowClass: 'animated fadeInDown', size: 'lg' });
    this.keyIndex = index;
    this.iconTab.patchValue({
      pickPoint: this.activityList[index].pickPoint,
      dropPoint: this.activityList[index].dropPoint,
      meetingStartDate: this.activityList[index].meetingStartDate,
      meetingEndDate: this.activityList[index].meetingEndDate,
      meetingStart: this.activityList[index].meetingStart,
      meetingEnd: this.activityList[index].meetingEnd,
      pickTime: this.activityList[index].pickTime,
      estDropTime: this.activityList[index].estDropTime,
      tagMembersMeet: this.activityList[index].tagMembersMeet,
      otherInfoCab: this.activityList[index].otherInfoCab,
      transNumberCab: this.activityList[index].transNumberCab,
      merchNameCab: this.activityList[index].merchNameCab,
      totalCabKms: this.activityList[index].totalCabKms,
      cabCategory: this.activityList[index].cabCategory,
    });
    this.selectedItems = this.activityList[index].tagMembersMeet
  }

  upDateCabActivity() {
    this.activityList[this.keyIndex] = {
      category: 'Cab',
      pickPoint: this.iconTab.value.pickPoint,
      dropPoint: this.iconTab.value.dropPoint,
      meetingStartDate: this.iconTab.value.meetingStartDate,
      meetingEndDate: this.iconTab.value.meetingEndDate,
      meetingStart: this.iconTab.value.meetingStart,
      meetingEnd: this.iconTab.value.meetingEnd,
      pickTime: this.iconTab.value.pickTime,
      estDropTime: this.iconTab.value.estDropTime,
      tagMembersMeet: this.iconTab.value.tagMembersMeet,
      otherInfoCab: this.iconTab.value.otherInfoCab,
      transNumberCab: this.iconTab.value.transNumberCab,
      merchNameCab: this.iconTab.value.merchNameCab,
      totalCabKms: this.iconTab.value.totalCabKms,
      cabCategory: this.iconTab.value.cabCategory,
    };

    this.iconTab.patchValue({
      activityDetails: this.activityList,
      category: "Cab",
      pickPoint: '',
      dropPoint: '',
      meetingStartDate: '',
      meetingEndDate: '',
      meetingStart: '',
      meetingEnd: '',
      pickTime: '',
      estDropTime: '',
      tagMembersMeet: '',
      otherInfoCab: '',
      transNumberCab: '',
      merchNameCab: '',
      totalCabKms: '',
      cabCategory: '',
    });
    this.keyIndex = -1;
  }

  getMinDate() {
    if (this.startDate) {
      return (this.startDate)
    } else {
      return this.minDate
    }
  }

  getDiffItem(key: any, val: any) {
    let d = _.groupBy(this.diffList, 'key')[key]
    if (d && d.length) {
      return d[0][val]
    }
  }

  readableDateFormat(userDate: any) {
    if (!_.isObject(userDate)) {
      return userDate;
    } else {
      let year = userDate.year;
      let month = userDate.month <= 9 ? '0' + userDate.month : userDate.month;;
      let day = userDate.day <= 9 ? '0' + userDate.day : userDate.day;;
      let finalDate = day + "-" + month + "-" + year;
      return finalDate;
    }
  }

  selectCabStartDate(event) {
    console.log(event);
    this.startDate = event;
    let year = event.year;
    let month = event.month <= 9 ? '0' + event.month : event.month;;
    let day = event.day <= 9 ? '0' + event.day : event.day;;
    let finalDate = day + "-" + month + "-" + year;
    this.iconTab.patchValue({
      meetingStartDate: finalDate
    })
    this["meetingStart"] = finalDate;
  }

  selectCabEndDate(event) {
    console.log(event);
    let year = event.year;
    let month = event.month <= 9 ? '0' + event.month : event.month;;
    let day = event.day <= 9 ? '0' + event.day : event.day;;
    let finalDate = day + "-" + month + "-" + year;
    this.iconTab.patchValue({
      meetingEndDate: finalDate
    })
    this["meetingEnd"] = finalDate;
  }

  addNewItem() {
    // RG
    Swal.fire({
      title: 'Are you sure, You want to Save?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
        if (!this.iconTab.value.pickPoint || !this.iconTab.value.dropPoint || !this.iconTab.value.meetingStart
          || !this.iconTab.value.pickTime || this.iconTab.value.tagMembersMeet.length == 0) {
          this.alertService.showError('Mandatory fields to be filled !');
          return false;
        }

        let isMatch = _.isMatch(this.data, this.iconTab.value);
        if (isMatch && this.isActivityEdit) {
          this.alertService.showError('No Changes made to amend !', 3000, 'Invalid update !')
          return false;
        }

        let activityDiffList = [];
        if (!isMatch && this.isActivityEdit) {
          let that = this;
          let old = _.clone(this.data), fresh = _.clone(this.iconTab.value);
          _.each(this.verifyFields, function(field) {
            let newVal = fresh[field.key], oldVal = old[field.key];
            if (old[field.key] != fresh[field.key]) {

              // if (field.key == 'meals' && newVal == 'No') {
              //   newVal = fresh['meals']
              // } else {
              //   newVal = fresh['meals']
              // }

              activityDiffList.push({
                key: field.key,
                name: field.value,
                oldVal: field.isDate ? that.readableDateFormat(old[field.key]) : oldVal,
                newVal: field.isDate ? that.readableDateFormat(fresh[field.key]) : newVal
              })
            }
          })
        }

        console.log('am in addNewItem ', activityDiffList, this.activityList, this.iconTab.value);
        this.flightData.emit({ ...this.iconTab.value, activityDiffList: activityDiffList, snapList: this.snapList, key: this.code, category: 'Cab', uniqueId: uuidv4(), addedBy: this.addedBy });
        this.closeModal();
      }
    })
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  chooseFile() {
    // RG
    Swal.fire({
      title: 'Are you sure, You want to Upload Confirmation Doc?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
        document.getElementById("avatar").click();
      }
    })
  }

  upload() {
    // Create a root reference
    let storageRef = firebase.storage().ref();
    this.isUploading = true;
    let that = this;

    for (let selectedFile of [(<HTMLInputElement>document.getElementById('avatar')).files[0]]) {
      // let path = '/BILLS/' + Date.now() + `${selectedFile.name}`;
      let path = '/BILLS/' + Date.now() + '_' + `${selectedFile.name}`;
      let iRef = storageRef.child(path);
      iRef.put(selectedFile).then((snapshot) => {
        snapshot.ref.getDownloadURL()
          .then((url) => {
            let images = that.snapList || [];
            images.push(url);
            that.snapList = images;
            this.isUploading = false;
          })
      });
    }
  }

  removeImage(index: any) {
    // RG
    Swal.fire({
      title: 'Are you sure, You want to Remove?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.snapList.splice(index, 1);
      }
    })
  }

  getFileName(url: any) {
    let data = '';
    if (url.split('_')[1]) {
      data = url.split('_')[1].split('?');
      data = data[0] ? decodeURI(data[0]) : '';
      return data;
    } else {
      return data;
    }
  }

}
